import CompanyRegistrationFormView from "./components/company-form-view"; // Update the path as needed
export default function CompanyPage() {
  return <CompanyRegistrationFormView />;
}
